import { render } from "./UndoRedoButtons.vue?vue&type=template&id=bb421070&scoped=true"
import script from "./UndoRedoButtons.vue?vue&type=script&lang=js"
export * from "./UndoRedoButtons.vue?vue&type=script&lang=js"

import "./UndoRedoButtons.vue?vue&type=style&index=0&id=bb421070&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb421070"]])

export default __exports__